var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgSpeed05 = function SvgSpeed05(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 17a.97.97 0 0 1-.713-.288A.97.97 0 0 1 14 16q0-.424.287-.713A.97.97 0 0 1 15 15h3v-2h-2q-.825 0-1.412-.588A1.93 1.93 0 0 1 14 11V9q0-.825.588-1.412A1.93 1.93 0 0 1 16 7h3q.424 0 .712.287Q20 7.576 20 8q0 .424-.288.713A.97.97 0 0 1 19 9h-3v2h2q.824 0 1.413.588Q20 12.175 20 13v2q0 .824-.587 1.413A1.93 1.93 0 0 1 18 17zm-9 0q-.824 0-1.412-.587A1.93 1.93 0 0 1 4 15V9q0-.825.588-1.412A1.93 1.93 0 0 1 6 7h2q.825 0 1.412.588Q10 8.175 10 9v6q0 .824-.588 1.413A1.93 1.93 0 0 1 8 17zm0-2h2V9H6zm6 2a.97.97 0 0 1-.713-.288A.97.97 0 0 1 11 16q0-.424.287-.713A.97.97 0 0 1 12 15q.424 0 .713.287.287.288.287.713 0 .424-.287.712A.97.97 0 0 1 12 17"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSpeed05);
export { ForwardRef as ReactComponent };